var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane",attrs:{"role":"tabcard","id":"customer"}},[_c('add-customer',{attrs:{"project":_vm.project}}),_vm._v(" "),(_vm.project && _vm.project.customers.length > 0)?_c('customer-list',{attrs:{"project":_vm.project,"user":_vm.user}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }